export default __webpack_public_path__ + "static/media/web-platform-card.3bbd448f.svg";